import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResizeGlyphComponent } from 'app/resize-glyph/resize-glyph.component';
import {SharedModule} from "../shared/shared.module";

@NgModule({
    imports: [CommonModule, SharedModule],
    declarations: [ResizeGlyphComponent],
    exports: [ResizeGlyphComponent]
})
export class ResizeGlyphModule {

}



// WEBPACK FOOTER //
// ./src/app/resize-glyph/resize-glyph.module.ts